<template>
  <DelDialog
    width="480px"
    :dialogVisible="uploadAnswerVisible"
    @handleClose="handleCancel"
    @handleConfirm="handleConfirm"
  >
    <template #title>{{$t('projectDetailsV2.uploadAnswer')}}</template>
    <ul>
      <li class="title">{{$t('projectDetailsV2.original')}}：</li>
      <li class="name">{{updateFileInfo.name}}</li>
      <li class="title">{{$t('projectDetailsV2.answer')}}：</li>
      <li>
        <el-upload class="upload-demo" drag action
          :limit="1"
          :accept="acceptStr"
          :file-list="updateFile"
          :show-file-list="false"
          :on-change="uploadChange"
          :on-exceed="handleExceed"
          :before-upload="beforeUploadFile"
          :http-request="uploadSectionFile"
        >
          <div class="emptyBox" v-if="updateFile.length ? false: true">
            <el-button size="small" type="primary">{{$t('projectDetailsV2.clickToUpload')}}</el-button>
            <div class="txt">{{$t('projectDetailsV2.limitSize')}}</div>
          </div>
          <div v-else class="file-upload-list">
            <div class="file-item" v-for="(item, index) in updateFile" :key="index">
              <div class="file-top">
                <el-tooltip effect="dark" :content="item.name" placement="top">
                  <span :class="`file-name icon-${updateFileInfo.fileSuffix}`">{{item.name}}</span>
                </el-tooltip>
              </div>
              <div class="file-bottom">
                <div class="progress"><el-progress :percentage="isNaN(item.percentage) ? 100 : item.percentage"></el-progress></div>
                <div class="del" @click.stop="handleDelete(index)"></div>
              </div>
            </div>
          </div>
        </el-upload>
      </li>
    </ul>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import axios from "axios";
import {
  uploadAnswer
} from '@/services/assignTaskApi';

import { getUploadSign } from '@/services/newProjectApi';

export default {
  name: 'uploadAnswer',
  components: {
    DelDialog
  },
  props: {
    uploadAnswerVisible: {
      type: Boolean,
      require: true,
    },
    updateFileInfo: {
      type: Object,
      require: true,
    },
  },
  data () {
    return {
      acceptStr: this.$supportFileSuffixes().acceptStr,  // 支持文件格式
      updateFile: [],
      form: {
        file: ''
      },
    }
  },
  methods: {
    uploadChange (file) {
      this.updateFile.push({
        ...file,
        imgSrc: '',
        path: '',
        source: '',
        sourceLang: '',
        obp: false
      });
    },
    handleExceed () {
      this.$message.closeAll();
      this.$message.warning(this.$t('newProjectV2.maxFileNum', [1]));
    },
    handleDelete (index) {
      this.form.file = ''
      this.updateFile.splice(index, 1);
    },
    beforeUploadFile (file) {
      let re = /([^\.\/\\]+)\.([a-z]+)$/i;
      let resultArr = re.exec(file.name);
      // 文件类型
      let type = resultArr[2].toLocaleLowerCase();
      // 文件是否超过大小
      let isLt20M = file.size / 1024 / 1024 > 20;

      let typeFlag = [`${this.updateFileInfo.fileSuffix}`].includes(type);

      if (!typeFlag) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.onlySupportFormate', [this.updateFileInfo.fileSuffix]));
        // 去除最后一个文件
        this.updateFile.pop();
        return false;
      }

      if (file.size < 1) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.notSupportEmptyFolder'));
        return false;
      }

      if (isLt20M) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.maxUploadFileSize', [20]));
        this.updateFile.pop();
        file.obp = true;
        return false;
      }
      return true;
    },
    uploadSectionFile (param) {
      let self = this;
      // 获得上传签名
      getUploadSign().then(({ result }) => {
        self.host = result.host;
        let re = /([^\.\/\\]+)\.([a-z]+)$/i;
        let resultArr = re.exec(param.file.name);
        // 文件类型
        let type = resultArr[2].toLocaleLowerCase();

        let para = {
          ...result,
          key : `${result.keyPrefix}.${type}`,
          file: param.file,
        };
        Reflect.deleteProperty(para, 'keyPrefix');
        Reflect.deleteProperty(para, 'host');

        self.formData = new FormData();
        Object.keys(para).forEach(function (key) {
          self.formData.append(key, para[key]);
        });

        self.getFileHost(param);
      })
    },
    getFileHost (param) {
      let self = this;
      let FileController = self.host;
      let config = {
        onUploadProgress: progressEvent => {
          const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({percent: complete});
        }
      };
      axios.post(FileController, self.formData, config).then((resp) => {
        let { result } = resp.data;
        self.updateFile.forEach((item, index) => {
          // 上传文件夹的param和单个上传的param不一样
          if (item.uid === param.file.uid) {
            item.path = result.fileName;
            self.$set(self.updateFile, index, item);
          }
        });
      });
    },
    handleCancel () {
      this.updateFile = [];
      this.$emit('uploadAnswerCancel');
    },
    async handleConfirm () {
      if (this.updateFile.length === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.selUploadFileTip'));
        return;
      }
      const { success } = await uploadAnswer({
        fileId: this.updateFileInfo.id,
        finish: this.updateFileInfo.finish,
        filePath: this.updateFile[0].path
      });
      if (success) {
        this.$message.closeAll();
        this.$message.success(this.$t('newProjectV2.uploadSuccess'));
        this.handleCancel();
      }
    },
  },
  watch: {
    updateFileInfo: {
      handler (val) {
        this.acceptStr = `.${val.fileSuffix}`;
      },
      deep: true,
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>